import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Btn.module.css';

export type BtnVariant = 'default' | 'primary' | 'dark' | 'ghost' | 'danger';
export type BtnSize = 'sm' | 'md' | 'lg';

interface BtnProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  variant?: BtnVariant;
  size?: BtnSize;
  icon?: ReactNode;
  fullWidth?: boolean;
  children?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

const SIZE_CLASS: Record<BtnSize, string> = {
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg,
};

const VARIANT_CLASS: Record<BtnVariant, string> = {
  default: styles.variantDefault,
  primary: styles.variantPrimary,
  dark: styles.variantDark,
  ghost: styles.variantGhost,
  danger: styles.variantDanger,
};

export function Btn({
  variant = 'default',
  size = 'md',
  icon,
  fullWidth = false,
  children,
  type = 'button',
  className,
  ...rest
}: BtnProps) {
  const classes = [
    styles.btn,
    SIZE_CLASS[size],
    VARIANT_CLASS[variant],
    fullWidth ? styles.fullWidth : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={classes} {...rest}>
      {icon && <span aria-hidden>{icon}</span>}
      {children}
    </button>
  );
}
